/**
 * @see https://stackoverflow.com/a/1308446/5506547
 */ function getDecimalSeparator() {
    return 1.1.toLocaleString(document.documentElement.lang).substr(1, 1);
}
const formatNumber = (number, fixed)=>{
    if (fixed === void 0) fixed = 2;
    return number.toFixed(fixed).replace(".", getDecimalSeparator());
};
export { getDecimalSeparator, formatNumber };
